import React, { ReactElement } from 'react';
import Modal from 'react-modal';

interface Props {
    modalVisible: boolean;
    setModalVisible: (value: boolean) => void;
    challengeData: any;
    setOnClickSuccess: () => void;
    setSubmittedAnswers?: any;
    selectedSection: number;
    selectedSectionHandler: (index: number) => void;
}

export default function StartChallengeModal({
    modalVisible,
    setModalVisible,
    challengeData,
    setOnClickSuccess,
    setSubmittedAnswers,
    selectedSection,
    selectedSectionHandler,
}: Props): ReactElement {
    const customStyles: Modal.Styles = {
        overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.25)',
            zIndex: 999,
        },
        content: {
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            padding: '0px',
            border: '0px',
            backgroundColor: 'transparent',
            zIndex: 999,
        },
    };

    const handleOnClickSubmit = () => {
        setOnClickSuccess();
        setSubmittedAnswers && setSubmittedAnswers(null);
        setModalVisible(false);

        if (selectedSection === 0) {
            selectedSectionHandler(-1);
        } else {
            selectedSectionHandler(0);
        }
    };

    const handleOnClickCancel = () => {
        setModalVisible(false);
    };

    return (
        <div>
            <Modal isOpen={modalVisible} style={customStyles} ariaHideApp={false}>
                <>
                    <div className="flex-shrink justify-center items-center flex fixed inset-0 z-50 outline-none focus:outline-none">
                        <div style={{ width: '531px' }} className="relative my-6  mx-auto">
                            <div
                                className="rounded-lg shadow-lg relative flex flex-col items-center w-full bg-white outline-none focus:outline-none px-4 py-3"
                                style={{ maxHeight: '324px' }}
                            >
                                <div
                                    style={{
                                        top: '-54px',
                                    }}
                                    className="flex flex-col items-center justify-center relative border-2 border-solid h-20 w-20 bg-white border-purple-700 rounded-full"
                                >
                                    <span className="challengeStart self-center pl-1"></span>
                                </div>

                                <div className="mb-2">
                                    <h1 className="text-xl font-bold">
                                        {
                                            challengeData?.StatusValue === 0
                                                ? 'Want to start this Challenge?' // try again
                                                : challengeData?.StatusValue === 1
                                                ? 'Want to start this Challenge?' // continue
                                                : 'Want to start this Challenge?' // start
                                        }
                                    </h1>
                                </div>
                                <div className=" text-black mb-8 text-center">
                                    {
                                        challengeData?.StatusValue === 0
                                            ? 'Click on Try Again to start working on this challenge and progress through Future Careers BRIDGE' // try again
                                            : challengeData?.StatusValue === 1
                                            ? 'Click to start working on this challenge and progress through Future Careers BRIDGE' // continue
                                            : 'Click to start working on this challenge and progress through Future Careers BRIDGE' // start
                                    }
                                </div>
                                <div className="flex flex-row gap-2 mb-6">
                                    <button
                                        className="w-40 px-2 text-purple-700 h-12 bg-white border border-purple-700 rounded font-bold"
                                        onClick={() => handleOnClickCancel()}
                                    >
                                        Later
                                    </button>
                                    <button
                                        className="w-40 px-2 bg-purple-700 h-12 text-white rounded font-bold"
                                        onClick={() => handleOnClickSubmit()}
                                    >
                                        {
                                            challengeData?.StatusValue === 0
                                                ? 'Try Again' // try again
                                                : challengeData?.StatusValue === 1
                                                ? 'Continue' // continue
                                                : 'Start' // start
                                        }
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            </Modal>
        </div>
    );
}
